import React from "react";
import { Box, Paper, Typography, useTheme } from "@mui/material";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import { useTranslation } from "react-i18next";

const OrdersStatusChart = ({ data = {} }) => {
  const { t } = useTranslation();

  const processedData = React.useMemo(() => {
    if (!data) return [];
    const statusMapping = {
      new_order: t("dashboard.status.new_order"),
      processing: t("dashboard.status.processing"),
      ready: t("dashboard.status.ready"),
      shipping: t("dashboard.status.shipping"),
      delivered: t("dashboard.status.delivered"),
      cancelled: t("dashboard.status.cancelled"),
      returned: t("dashboard.status.returned"),
    };

    return Object.keys(statusMapping).map((key) => ({
      name: statusMapping[key],
      count: data[key] || 0,
    }));
  }, [data, t]);

  return (
    <Paper
      elevation={0}
      sx={{
        p: 3,
        height: "100%",
        borderRadius: "16px",
        boxShadow: "0px 2px 10px rgba(0,0,0,0.05)",
      }}
    >
      <Box
        sx={{
          mb: 4,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
        }}
      >
        <Box>
          <Typography variant="h6" sx={{ fontWeight: 700 }}>
            {t("dashboard.number_of_orders")}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {t("dashboard.orders_by_status_sub")}
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            bgcolor: "#F5F5F5",
            px: 1.5,
            py: 0.5,
            borderRadius: 2,
          }}
        >
          <CalendarTodayIcon
            sx={{ fontSize: 14, color: "text.secondary", mr: 1 }}
          />
          <Typography variant="caption" color="text.secondary">
            21 Aug 2025 - 21 Sep 2025
          </Typography>
        </Box>
      </Box>

      <div style={{ width: "100%", height: 350 }}>
        <ResponsiveContainer>
          <BarChart
            data={processedData}
            margin={{
              top: 5,
              right: 30,
              left: 20,
              bottom: 5,
            }}
            barSize={20}
          >
            <CartesianGrid
              strokeDasharray="3 3"
              vertical={false}
              stroke="#f0f0f0"
            />
            <XAxis
              dataKey="name"
              axisLine={false}
              tickLine={false}
              tick={{ fontSize: 12, fill: "#666" }}
              dy={10}
            />
            <YAxis
              axisLine={false}
              tickLine={false}
              tick={{ fontSize: 12, fill: "#666" }}
              orientation="right"
              dx={10}
            />
            <Tooltip
              cursor={{ fill: "transparent" }}
              contentStyle={{
                borderRadius: 8,
                border: "none",
                boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
              }}
            />
            <Bar
              dataKey="count"
              fill="#6C4192"
              radius={[10, 10, 10, 10]}
              label={{ position: "top", fill: "#666", fontSize: 12 }}
            />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </Paper>
  );
};

export default OrdersStatusChart;
